import React from 'react';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';
import Grid from '../../../components/molecules/Grid';
import Tabs from '../../../components/molecules/Tabs';
import { COMPONENT_NAME } from './locators';
import Container from '../../../components/molecules/Container';
import MapViewer from '../../../components/molecules/MapViewer';
import { getHelperKeysFromDictionary } from '../../../../utils/utility';
import { dictionaryKeys } from '../BranchesMap/BranchesMap';
import { evalConditionForInsideChina } from '../../../utils/cookie';
import { LANGUAGE_CODE } from '../../../../constants';
import { getComponentName, getPageName } from '../../../utils/getPageComponentInfo';
import { NoSsr } from '@material-ui/core';
import { getAPIKey } from '../../../utils/getApiKey';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';

const ItineraryMap = (props) => {
  const { sitecoreContext, t } = props;
  const classes = useStyles();
  const componentName = getComponentName(props);
  const pageName = getPageName(props);
  const language = get(sitecoreContext, 'language', LANGUAGE_CODE.DEFAULT);
  //const [isMapLoaded, setIsMapLoaded] = useState(true);

  const helperKeys = getHelperKeysFromDictionary(t, dictionaryKeys);

  const title = get(sitecoreContext, 'route.fields.mapTitle', undefined);
  const highlightsTabTitle = get(sitecoreContext, 'route.fields.mapTabName', {
    value: 'HIGHLIGHTS',
  });

  const iteneraries = get(sitecoreContext, 'route.fields.dayItineraries', []);
  const apiKey = getAPIKey(language, sitecoreContext);

  const collageTabs = [
    { fields: { title: { value: highlightsTabTitle.value } } },
    ...iteneraries,
  ];

  const getMarkers = index => {
    return index === 0 ? getAllMarkers() : getMarkersForDay(index);
  };

  const getMarkersForDay = index => {
    return collageTabs[index].fields.stops.map((stop, i) => {
      if (isLatLngAvailable(stop.fields)) {
        return getMarkerFormated(stop.fields, `${i + 1}`);
      } else return null;
    });
  };

  const isLatLngAvailable = fields => {
    return (
      get(fields, 'longitude.value', false) &&
      get(fields, 'latitude.value', false)
    );
  };

  const getAllMarkers = () => {
    const allStops = [];
    iteneraries.forEach((itr, i) => {
      itr.fields.stops.forEach((stop, j) => {
        if (isLatLngAvailable(stop.fields)) {
          allStops.push(getMarkerFormated(stop.fields, `${i + 1}${j + 1}`));
        }
      });
    });

    return allStops;
  };

  const getMarkerFormated = (fields, idText) => {
    return {
      id: idText,
      name: get(fields, 'stopHeading.value', ''),
      lat: parseFloat(get(fields, 'latitude.value', 0)),
      lng: parseFloat(get(fields, 'longitude.value', 0)),
      address: get(fields, 'location.value', ''),
    };
  };

  const tabData = (tabText, index) => {
    return (
      <MapViewer
        {...{
          language,
          markers: getMarkers(index),
          isRouteDirection: index === 0 ? false : true,
          isPolyline: false,
          showLegend: index === 0 ? false : true,
          isItinerary: true,
          labels: helperKeys,
          isRedMarker: index === 0 ? true : false,
          apiKey,
          itineraryMapUrl: get(sitecoreContext, 'route.fields.itineraryMapUrl.value.href'),
        }}
        componentName={componentName}
        pageName={pageName}
      />
    );
  };

  const createTabs = collageTabs.map((collageTab, i) => {
    const tabTitle = get(collageTab, 'fields.title.value', '');
    return {
      data: tabData(tabTitle, i),
      label: tabTitle,
    };
  });

  if (evalConditionForInsideChina(language)) {
    return null;
  }

  // if (isMapLoaded && isLanguageEqual(language, LANGUAGE_CODE.CHINESE)) {
  //   fetch(modifyApi(BAIDU_MAP_API_URL, { apiKey }))
  //     .catch(err => {
  //       console.log("Map is not loading due to: ", err);
  //       setIsMapLoaded(false);
  //     });
  // }
  // if (!isMapLoaded) {
  //   return null;
  // }

  return (
    <div className={classes.root} data-locator={COMPONENT_NAME}>
      <Container data-locator={COMPONENT_NAME}>
        <NoSsr>
          {iteneraries.length > 0 && collageTabs.length > 0 && apiKey && <Grid>
            {title && (
              <Typography variant="h4" component="h2" className={classes.title}>
                <Text field={title} />
              </Typography>
            )}
            <Tabs tabs={createTabs} className={classes.tabsContainer} />
          </Grid>}
        </NoSsr>
      </Container>
    </div>
  );
};

export default withErrorBoundary(withSitecoreContext()(withNamespaces()(ItineraryMap)));
